
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSettingsDefaultIec as ObiSettingsDefaultIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-settings-default-iec.js';
 
 
 

 
 export const ObiSettingsDefaultIec = createComponent({
   react: React,
   tagName: 'obi-settings-default-iec',
   elementClass: ObiSettingsDefaultIecElement,
   events: {
     
   }
  });
 
 